<template>
  <v-card>
    <v-card-text class="pa-0">
      <div class="grid-container">
        <table>
          <thead>
            <tr class="header-row text-caption white">
              <th class="sticky-date-header">
                <div class="cell d-flex flex-column px-0">
                  <span class="text-uppercase text-left font-weight-bold">
                    {{ $t("date") }}
                  </span>
                </div>
              </th>
              <th
                v-for="column in columns"
                :key="column.room_rate_id"
                :class="{
                  'header-hovered':
                    hovered_room_rate_id === column.room_rate_id,
                  'header-selected': isColumnSelected(column.room_rate_id)
                }"
              >
                <div
                  class="cell d-flex justify-center flex-column font-weight-bold"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        class="d-block text-uppercase text-truncate grey--text text--darken-3"
                      >
                        {{
                          columns.length >= 10
                            ? column.room_rate_code
                            : column.room_rate_name
                        }}
                      </span>
                    </template>
                    <span>{{ column.room_rate_name }}</span>
                  </v-tooltip>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <a-ref-prices-table-row
              v-for="row in rows"
              :key="row.date"
              :row="row"
              :columns="columns"
              :selection="selection"
              :events="events_data ? events_data[row.date] : []"
              @cell-click="handleCellClick"
              @cell-hover="handleCellHover"
              @cell-hover-date="$emit('cell-hover-date', $event)"
            />
          </tbody>
        </table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import aRefPricesTableRow from "@/components/settings/aRefPricesTableRow.vue";

export default {
  name: "a-ref-prices-table",
  components: {
    aRefPricesTableRow
  },
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    selection: {
      type: Object,
      default: () => ({})
    },
    events_data: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    hovered_room_rate_id: null
  }),
  methods: {
    handleCellClick(payload) {
      this.$emit("cell-click", payload);
    },
    handleCellHover(roomRateId) {
      this.hovered_room_rate_id = roomRateId;
      this.$emit("cell-hover", roomRateId);
    },
    isColumnSelected(roomRateId) {
      return (
        this.selection.room_rate_ids &&
        this.selection.room_rate_ids.includes(roomRateId)
      );
    }
  }
};
</script>

<style scoped lang="scss">
.grid-container {
  --heightHeaderRow: 40px;
  --widthColumnDate: 160px;

  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  max-height: calc(100vh - 275px);
  position: relative;

  table {
    border-spacing: 0;
    width: 100%;
    table-layout: fixed;

    thead {
      position: sticky;
      top: 0;
      z-index: 3;
      tr {
        th {
          border-bottom: 2px solid #ddd;
          border-right: 1px solid #eee;
          font-weight: 400;
          padding: 4px 10px;
          background: white;

          .cell {
            padding: 0 5px;
            text-align: center;
            height: 100%;
            justify-content: center;
            overflow: hidden;
          }

          &.sticky-date-header {
            position: sticky;
            left: 0;
            z-index: 4;
            width: var(--widthColumnDate);
            min-width: var(--widthColumnDate);
            border-right: 2px solid #ddd;

            .cell {
              width: 100%;
            }
          }
          &.header-hovered {
            border-bottom-color: #2d6ece;
          }
          &.header-selected {
            background-color: rgba(0, 132, 200, 0.1);
            border-bottom: 2px solid #1576c7;
          }
        }
      }
    }
  }
}
</style>
